<kit-page-header [backgroundWhite]="false"
                 [description]="'Download lease Point-of-sale data'"
                 [fullWidthDescription]="true"
                 [section]="'Leasing Point-of-Sale'"
                 [title]="'Download lease Point-of-sale data.'"
></kit-page-header>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div>
  <app-lease-pos></app-lease-pos>
</div>



